<template>
  <div
    class="cursor-pointer bg-sideMenuBackground rounded-lg flex flex-col pl-4 py-6 mb-8"
    @click="$router.push('/profile')"
  >
    <div class="flex flex-row items-center justify-between sm:justify-start gap-x-4">
      <UserProfileImage size="lg" :user="$parse.User.current()" />
      <div class="flex flex-col leading-5 text-sideMenuForeground">
        <span class="text-xl">{{ useUserHelper.getFullName(Parse.User.current()) }}</span>
        <span class="text-sm">{{ `${Parse.User.current().get('position')}` }}</span>
      </div>
      <i class="material-icons block sm:hidden">arrow_forward_ios</i>
    </div>
  </div>
</template>

<script setup>
import useUserHelper from '@/composables/useUserHelper.js';
import Parse from 'parse';
import UserProfileImage from '@/components/atoms/UserProfileImage.vue';
</script>
